(function () {
    angular.module('toTopButton', [])
        .directive('toTopButton', ['$window',
            function ($window) {
                return {
                    restrict: 'AE',
                    replace: false,
                    transclude: false,
                    controller: ['$scope', '$window', '$timeout',
                        function ($scope, $window, $timeout) {
                            $scope.buttonIsVisible;

                            const button = document.getElementById('toTopButton');

                            if (!'IntersectionObserver' in $window) {
                                //automatically show button if browser doesn't support IO
                                button.style.display = "inline-block";
                            } else {

                                const options = {
                                    root: null,
                                    rootMargin: '0px',
                                    threshold: 1.0
                                }

                                /**
                                 * @param entries: target (will be only one, but IO needs an array)
                                 * @param obs: obsrver
                                 * */
                                const observer = new IntersectionObserver(function (entries, obs) {
                                    entries.forEach(e => {
                                        if (e.isIntersecting) {
                                            $scope.buttonIsVisible = false;

                                            button.style.opacity = 0;

                                            $timeout(function () { // wait for animation to finish
                                                button.style.display = "none";
                                            }, 601); // time is .01 second longer than the css transition time
                                            
                                        } else {
                                            $scope.buttonIsVisible = true;

                                            button.style.display = "inline-block";

                                            $timeout(function () {
                                                button.style.opacity = 1;
                                            }, 601);
                                        }
                                        $scope.$apply();
                                    })
                                }, options);

                                const target = document.querySelectorAll('#ioTrigger')[0];

                                observer.observe(target);
                            }
                        }
                    ]
                }
            }
        ]);
}());